const WEBSITE_URL = process.env.GATSBY_SITE_URL

const author = {
  name: 'Lucidworks',
  email: '',
  url: WEBSITE_URL,
}

const site = {
  pathPrefix: '/',
  title: 'Lucidworks Documentation',
  description: 'A documentation site for Lucidworks products',
  siteUrl: `${WEBSITE_URL}/`,
  // googleTrackingId: 'UA-8457997-9',
  g4tagId: 'G-8ZS8N36PQN',
  lang: 'en',
  displayTranslations: true,
};

const repository = {
  url: 'https://github.com/lucidworks/fusion-docs-site',
  name: 'fusion-docs-site',
  displaysLink: true,
}

const articles = {
  filePath: { Asciidoc: 'paths.from.source.full' },
  ignore: ['asciidoctor-examples/**/*.adoc'],
};

module.exports = {
  author,
  site,
  repository,
  articles,
  WEBSITE_URL
};
